import script from "./gDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./gDetail.vue?vue&type=script&setup=true&lang=js"

import "./gDetail.vue?vue&type=style&index=0&id=0d77f606&lang=scss"

const __exports__ = script;

export default __exports__